import { Query } from '@damofire/data-commons';
import { Asset } from '../asset/asset.dto';
import { Noteable } from '../note/note.dto';

export interface Inspection extends Noteable, DeleteInspectionAssets {
  name?: string;
  reviewer?: string;
  status?: InspectionStatus;
  markCompleted?: boolean;
  issues?: number;
  reviews?: InspectionAssetReview[];
  importId?: string;
  savedSearchScope?: string;
  snapshotId?: string;
  /** Mobile only: completed here, and the server should wait for the sync to push everything before snapshotting it. */
  awaitingSync?: boolean;
}

export interface DeleteInspectionAssets {
  deleteIssues?: boolean;
}

export interface InspectionStatus {
  progress?: number;
  status?: InspectionResolutionStatus;
  unreviewedCnt?: number;
  reviewedCnt?: number;
  total?: number;
}

export enum InspectionResolutionStatus {
  OPEN,
  RESOLVED,
}

export enum InspectionDisplayStatus {
  DOCUMENTS = 'documents',
  STATISTICS = 'statistics',
  SUMMARY = 'summary',
}

export interface InspectionAssetReview {
  _id: string;
  toReview: boolean;
}

export type FullAssetReview = Asset & InspectionAssetReview;

export interface InspectionQuery extends Query {
  filters: { 'inspection._id': number; [key: string]: string | number };
}

export const NO_INSPECTION_ID = 'NONE';
